import { defineMessages } from 'react-intl';

export default defineMessages({
  DeviationOverview: {
    id: 'DeviationOverview',
    defaultMessage: 'Matrix task schedules per relation',
  },
  Relation: {
    id: 'Relation',
    defaultMessage: 'Relation',
  },
  Assignment: {
    id: 'Assignment',
    defaultMessage: 'Assignment',
  },
  Totals: {
    id: 'Totals',
    defaultMessage: 'Totals',
  },
  SelectOverviewColumns: {
    id: 'DeviationOverviewSelectColumns',
    defaultMessage: 'Select columns',
  },
  ColumnConfig: {
    id: 'ColumnConfig',
    defaultMessage: 'Column config',
  },
  NoDataFound: {
    id: 'NoDataFound',
    defaultMessage: 'No data found',
  },
  WithoutSchedule: {
    id: 'WithoutSchedule',
    defaultMessage: 'Without schedule',
  },
  DrillDown: {
    id: 'DeviationOverviewDrillDown',
    defaultMessage: 'Show subtasks',
  },
  BackToOverview: {
    id: 'DeviationOverviewBackToOverview',
    defaultMessage: 'Back to overview',
  },
  AllMainTasks: {
    id: 'DeviationOverviewAllMainTasks',
    defaultMessage: 'All main tasks',
  },
  ExportToExcel: {
    id: 'ExportToExcel',
    defaultMessage: 'Export to Excel',
  },
  ExportToExcelStarted: {
    id: 'ExportToExcelStarted',
    defaultMessage: 'Export to Excel started',
  },
  RelationLabels: {
    id: 'RelationLabels',
    defaultMessage: 'Relation labels',
  },
  Assignments: {
    id: 'WithAssignments',
    defaultMessage: 'Assignments',
  },
  GlobalActions: {
    id: 'GlobalActions',
    defaultMessage: 'Global actions',
  },
  UpdateExecutionDuration: {
    id: 'DeviationOverviewUpdateExecutionDuration',
    defaultMessage: 'Update execution duration',
  },
  SelectTargetTasks: {
    id: 'DeviationOverviewSelectTargetTasks',
    defaultMessage: 'Apply to',
  },
  MainTask: {
    id: 'DeviationOverviewMainTask',
    defaultMessage: 'Main task',
  },
  OnlyMainTask: {
    id: 'DeviationOverviewOnlyMainTask',
    defaultMessage: 'Only the main task',
  },
  SetExecutionDurationTo: {
    id: 'DeviationOverviewSetExecutionDurationTo',
    defaultMessage: 'Set execution duration to',
  },
  ResetToTemplateValue: {
    id: 'DeviationOverviewResetToTemplateValue',
    defaultMessage: 'Reset to the task template value',
  },
  PropagateToPlannedTasks: {
    id: 'DeviationOverviewPropagateToPlannedTasks',
    defaultMessage: 'Apply the changes to the open tasks on the taskboard',
  },
  AllDeviations: {
    id: 'DeviationOverviewAllDeviations',
    defaultMessage: 'All',
  },
  WithDeviation: {
    id: 'DeviationOverviewWithDeviation',
    defaultMessage: 'With deviation',
  },
  WithoutDeviation: {
    id: 'DeviationOverviewWithoutDeviation',
    defaultMessage: 'Without deviation',
  },
  BulkUpdateStarted: {
    id: 'DeviationOverviewBulkUpdateStarted',
    defaultMessage: 'The execution durations are being updated in the background.',
  },
  NoRowsSelected: {
    id: 'DeviationOverviewNoRowsSelected',
    defaultMessage: 'Select at least one row',
  },
  EditDeviation: {
    id: 'DeviationOverviewEditDeviation',
    defaultMessage: 'Open task schedule deviations',
  },
  TemplateValue: {
    id: 'DeviationOverviewTemplateValue',
    defaultMessage: 'Task template value',
  },
  ColumnDefaultDurationTooltip: {
    id: 'DeviationOverviewColumnDefaultDurationTooltip',
    defaultMessage: 'Planned duration from the task template',
  },
  MultipleSchedulesFound: {
    id: 'DeviationOverviewMultipleSchedulesFound',
    defaultMessage:
      'Multiple task schedules were found for this task. Edit the deviations in the relation file.',
  },
});
